<div
  class="device-info-container columns is-multiline is-gapless is-hidden-mobile"
>
  <div class="column is-one-third">
    <img
      class="device-image"
      src="{{ device.imageLocation }}"
      [attr.alt]="device.productDescShort"
    />
  </div>
  <div class="column is-two-thirds">
    <div class="device-title-container">
      <label class="device-title">{{ device.productDescShort }}</label>
    </div>
    <div class="buffer-large"></div>
    <div>
      <label class="device-info-header">{{ specsHeader }}</label>
    </div>
    <table>
      <tr>
        <td class="info-label">{{ processorLabel }}</td>
        <td class="info-text">{{ device.cpuModel }}</td>
      </tr>
      <tr>
        <td class="info-label">{{ memoryLabel }}</td>
        <td class="info-text">
          {{ device.memorySize }} {{ device.memoryUnit }}
        </td>
      </tr>
      <tr>
        <td class="info-label">{{ storageLabel }}</td>
        <td class="info-text">
          {{ device.diskDriveSize }} {{ device.diskDriveUnit }}
          {{ device.diskDriveType }}
        </td>
      </tr>
      <tr>
        <td class="info-label">{{ displayLabel }}</td>
        <td class="info-text">{{ device.screenSize }}</td>
      </tr>
    </table>
    <div class="buffer-medium"></div>
    <div>
      <label class="device-info-header">{{ descriptionHeader }}</label>
    </div>
    <p class="device-desc">
      {{ device.productDescLong }}
    </p>
    <div class="buffer-medium"></div>
    <div class="columns">
      <div class="column is-half" *ngIf="showLearnMoreButton">
        <button
          tabindex="0"
          mat-flat-button
          class="secondary learn-more-button"
          (click)="learnMoreBtnClick(device)"
          [attr.aria-label]="learnMoreScreenReaderText"
        >
          <span aria-hidden="true">{{ learnMoreButtonText }}</span>
        </button>
      </div>
      <div class="column" id="addToCartClick" *ngIf="showAddToCartButton">
        <form>
        <button
          *ngIf="showAddToCartButton"
          mat-flat-button
          class="secondary"
          (click)="addToCartClick(device, itemQuantity.value)" type="submit"
        >ADD TO CART</button>
        <label style="margin-left: 10px;">QTY: </label>
        <input matInput id="itemQuantityInput" placeholder="1" value="1" type="number" min="1" max="99999" appearance="fill" #itemQuantity required>
        <h3 name="formQuantityError">{{formQuantityError}}</h3>
        </form>
      </div>
    </div>
    <label *ngIf="showIncludeLicenseCheckbox">Include Chrome Enterprise License Upgrade</label><br/>
    <mat-radio-group [(ngModel)]="subscriptionChoice" *ngIf="showIncludeLicenseCheckbox">
      <mat-radio-button *ngFor="let data of subscriptionList" [name]="data.name" [value]="data.value">{{data.name}}</mat-radio-button>
    </mat-radio-group>
  </div>
</div>
<div
  class="device-info-container columns is-multiline is-mobile is-gapless is-hidden-tablet"
>
  <div class="column is-one-third" (click)="learnMoreBtnClick(device)">
    <img
      class="device-image"
      src="{{ device.imageLocation }}"
      [attr.alt]="device.productDescShort"
    />
  </div>
  <div class="column is-two-thirds" (click)="learnMoreBtnClick(device)">
    <div class="device-title-container">
      <label class="device-title">{{ device.productDescShort }}</label>
    </div>
  </div>
  <div class="column">
    <div
      class="mobile-device-detail-container"
      [ngClass]="{ 'include-border': includeBottomBorderMobile }"
    >
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ additionalDetailsHeader }}
            </mat-panel-title>
            <mat-panel-description> </mat-panel-description>
          </mat-expansion-panel-header>
          <div>
            <div>
              <div class="buffer-medium"></div>
              <div class="info-label">
                {{ processorLabel }}
              </div>
              <div class="info-text">
                {{ device.cpuModel }}
              </div>
              <div class="buffer-small"></div>
            </div>
            <div>
              <div class="info-label">
                {{ memoryLabel }}
              </div>
              <div class="info-text">
                {{ device.memorySize }} {{ device.memoryUnit }}
              </div>
              <div class="buffer-small"></div>
            </div>
            <div>
              <div class="info-label">
                {{ storageLabel }}
              </div>
              <div class="info-text">
                {{ device.diskDriveSize }} {{ device.diskDriveUnit }}
                {{ device.diskDriveType }}
              </div>
              <div class="buffer-small"></div>
            </div>
            <div>
              <div class="info-label">
                {{ displayLabel }}
              </div>
              <div class="info-text">
                {{ device.screenSize }}
              </div>
              <div class="buffer-small"></div>
            </div>
            <div>
              <div class="info-label">
                {{ formFactorsLabel }}
              </div>
              <div class="info-text">
                {{ device.productType }}
              </div>
              <div class="buffer-small"></div>
            </div>
            <div>
              <div class="info-label">
                {{ osTypeLabel }}
              </div>
              <div class="info-text">
                {{ device.osType }}
              </div>
              <div class="buffer-small"></div>
            </div>
            <div>
              <div class="info-label">
                {{ additionalFeaturesLabel }}
              </div>
              <div class="info-text">
                {{ device.productDescLong }}
              </div>
              <div class="buffer-medium"></div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
